module.exports = __webpack_public_path__ + "img/destination.8330699b.svg";